'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('../../../common/components/button');

var _button2 = _interopRequireDefault(_button);

var _createAccountTrigger = require('../../../hellosign/components/auth/create-account-trigger');

var _createAccountTrigger2 = _interopRequireDefault(_createAccountTrigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO Signup or Login Button',

    propTypes: {
        isUserLoggedIn: _react2['default'].PropTypes.bool.isRequired,
        homeUrl: _react2['default'].PropTypes.string.isRequired,
        buttonText: _react2['default'].PropTypes.string.isRequired,
        buttonUrl: _react2['default'].PropTypes.string.isRequired
    },

    triggerSelector: 'try-it-free-link',

    renderButton: function renderButton() {
        var defaultButtonClass = {
            buttonTextColor: 'white',
            buttonColor: 'goldenrod',
            buttonBorderColor: 'goldenrod',
            buttonHoverColor: 'white',
            buttonHoverTextColor: 'goldenrod'
        };
        var buttonContent = {
            buttonText: this.props.buttonText,
            buttonLink: this.props.homeUrl
        };
        return _react2['default'].createElement(_button2['default'], _extends({}, defaultButtonClass, buttonContent, this.props));
    },

    renderSignupForm: function renderSignupForm() {
        var linkClassName = 'm-button bg-goldenrod hc-goldenrod border-1-goldenrod' + ' hbg-white c-white progress-button state-loading m-marketing-page--button';
        var linkClassName = this.props.buttonClass || linkClassName;
        var trigger = _jsx('a', {
            className: linkClassName
        }, void 0, this.props.buttonText);
        var createAccountProps = {
            trigger: trigger,
            key: 'create_free_acct_trigger_qs_es',
            header: 'Get started'
        };
        return _react2['default'].createElement(_createAccountTrigger2['default'], _extends({}, createAccountProps, this.props));
    },

    render: function render() {
        var className;
        if (!this.props.isIntegration) {
            className = 'l-padding-t-10 l-padding-b-10 text-center m-marketing-page--try-it-free';
        }
        return _jsx('div', {
            className: className
        }, void 0, this.props.isUserLoggedIn ? this.renderButton() : this.renderSignupForm());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/signup-or-login-button.jsx
 ** module id = 812
 ** module chunks = 0
 **/